import { cn } from '@/shared/utils';
import type { SidebarWorkspaceView } from '@/viewmodel/features/workspace';
import { Lock } from 'lucide-react';

export function SidebarWorkspaceFooter({
  workspace,
}: {
  readonly workspace: SidebarWorkspaceView | null;
}) {
  if (!workspace) return null;

  const { name, initial, tier, locked } = workspace;

  return (
    <div className="flex shrink-0 items-center gap-2.5 border-t border-border p-3">
      <div className="grid size-7 shrink-0 place-items-center rounded-sm bg-mint font-display text-body-sm font-bold text-mint-foreground">
        {initial}
      </div>
      <div className="min-w-0">
        <div className="truncate font-display text-body-sm font-semibold leading-none text-foreground">
          {name}
        </div>
        {tier && (
          <div
            className={cn(
              'mt-1 flex items-center gap-1 truncate font-mono text-2xs uppercase tracking-widest',
              locked ? 'text-destructive' : 'text-muted-foreground',
            )}
          >
            {locked && <Lock size={10} aria-hidden />}
            {tier}
          </div>
        )}
      </div>
    </div>
  );
}
